import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomReportListTableView from '../components/content/reports/CustomReportListTableView';
import { REPORT_VIEW_TABS } from '../components/content/navigation/links';
import ReportTableListView from '../../components/content/analytics/ReportTableListView';
import { regAssociationAnalyticsAndReportsConfig } from '../../components/content/analytics/regAssociationAnalyticsAndReportsConfig';
import RegAssociationReportView from '../components/content/reports/RegAssociationReportView';
import AssociationReportTableView from '../../components/content/reports/AssociationReportTableView';

const ReportViews = ({ loading }) => (
  <Routes>
    <Route
      element={
        <ReportTableListView
          baseUrl="/admin"
          headerTitle="Reports"
          loading={loading}
          reports={regAssociationAnalyticsAndReportsConfig.reports}
          tabs={REPORT_VIEW_TABS}
        />
      }
      path="/templates"
    />
    <Route
      element={
        <CustomReportListTableView
          baseUrl="/admin"
          headerTitle="Reports"
          tabs={REPORT_VIEW_TABS}
        />
      }
      path="/custom"
    />

    <Route
      element={<RegAssociationReportView viewType="staff" />}
      path="/staff-report"
    />
    <Route element={<RegAssociationReportView />} path="/:uuid" />
    <Route
      element={<RegAssociationReportView viewType="custom" />}
      path="/custom/:pkRegAssociationSavedTemplate"
    />
    <Route
      element={<AssociationReportTableView />}
      path="/:pkRegAssociation/:pkRegReport"
    />
    <Route
      element={<Navigate replace to="/admin/reports/templates" />}
      path="*"
    />
  </Routes>
);

ReportViews.propTypes = { loading: PropTypes.bool };

export default ReportViews;
